import { render, staticRenderFns } from "./doQuestion.vue?vue&type=template&id=223efeae&scoped=true&"
import script from "./doQuestion.vue?vue&type=script&lang=js&"
export * from "./doQuestion.vue?vue&type=script&lang=js&"
import style0 from "./doQuestion.vue?vue&type=style&index=0&id=223efeae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223efeae",
  null
  
)

export default component.exports